export const contractCancellation = {
  'Contract cancellation': 'Acompanhar cancelamento',
  'Track the progress of your contract cancellation request':
    'Acompanhe o andamento da sua solicitação de cancelamento de contrato',
  'Contract nº {{code}}': 'Contrato nº {{code}}',
  'Requested on {{date}}': 'Solicitado em {{date}}',
  'Signature deadline: {{date}}': 'Prazo para assinatura: {{date}}',
  'Sign term now': 'Assinar termo agora',
  'Request again': 'Solicitar novamente',
  'Request new link': 'Solicitar novo link',
  'Your cancellation goes back to our team for review, and we will send you a new signature link by e-mail. Do you want to continue?':
    'Seu cancelamento volta para a análise da nossa equipe, que vai enviar um novo link de assinatura por e-mail. Deseja continuar?',
  'Not now': 'Agora não',
  'Yes, request': 'Sim, solicitar',
  'Request received! Our team will review your cancellation and send you a new signature link by e-mail.':
    'Solicitação recebida! Nossa equipe vai analisar o seu cancelamento e enviar um novo link de assinatura por e-mail.',
  'Sent communications': 'Comunicações enviadas',
  'No communications sent so far.':
    'Nenhuma comunicação enviada até o momento.',
  'It was not possible to load the communications.':
    'Não foi possível carregar as comunicações.',
  "You don't have a cancellation in progress.":
    'Você não tem cancelamento em andamento.',
  'It was not possible to load the cancellation tracking.':
    'Não foi possível carregar o acompanhamento do cancelamento.',
};
